import { SettingsAnswerEmptyValue } from 'Constants/Settings'
import { TranslationKeys } from 'Constants/TranslationKeys'
import { renderTranslation } from 'Helpers/GenericHelpers'
import { PossibleValues } from 'Slices/Settings/SettingsSlice'
import { Select } from 'antd'
import { useAppSelector } from 'hooks'

interface StandardSelectProps {
  storedValue: any
  storeValue: Function
  userCanEdit: boolean
  isOptional: boolean
  possibleValues: PossibleValues
}

function StandardSelect(props: StandardSelectProps) {
  const language = useAppSelector(state => state.present.language.value)
  const options = [
    ...(props.isOptional
      ? [
          {
            value: SettingsAnswerEmptyValue,
            label: renderTranslation(language, TranslationKeys.emptyOnSingleanswer),
          },
        ]
      : []),
    ...Object.entries(props.possibleValues)
      .filter(([value]) => value !== null && value !== undefined)
      .map(([key, value]) => ({
        value: key,
        label: value.value,
      })),
  ]

  return (
    <Select
      options={options}
      style={{ width: 100 }}
      value={props.storedValue}
      onChange={(value, option) => {
        props.storeValue(value)
      }}
      getPopupContainer={triggerNode => {
        return document.getElementById('page-content-settings')
      }}
      disabled={!props.userCanEdit}
    />
  )
}

export default StandardSelect
